export const COLUMNS_LOCAL_STORAGE_KEY = 'settlementsSettledDateQueueColumns';
export const COLUMNS_WIDTH = 160;
